export default __webpack_public_path__ + "static/publicis-france-share-ff4c06c8351ee8190fd31710a54ddc45.png";